export enum InlineCommentFramework {
	BACKBONE = 'backbone',
	REACT = 'react',
	ANNOTATION_PROVIDER = 'annotation-provider',
}
